import React, { useRef, useEffect } from 'react';
import { default as __ } from '../../utils';

function Toast({ id, msg, cb, icon }) {
  let wrapRef = useRef(null);

  useEffect(() => {
    open();
  }, []);

  function open() {
    __.timeline().then(() =>
      __.animate(wrapRef, {
        transform: `translateY(12px)`,
        opacity: 1,
        visibility: 'visible',
      }),
    );
  }

  function close() {
    /* eslint-disable */
    __.timeline()
      .then(() =>
        __.animate(wrapRef, {
          transform: `translateY(-200px)`,
        }),
      )
      .then(() =>
        __.animate(wrapRef, {
          opacity: 0,
          visibility: 'visible',
        }),
      )
      .then(() => cb(id));
  }

  return (
    <div
      onClick={() => close()}
      toast-animation="item"
      className="col-center align-center"
      ref={wrapRef}
    >
      {icon && icon === 'fail' ? (
        <span className="txt-l -purple">&times;</span>
      ) : (
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="var(--purple)"
          style={{ transform: 'scale(2)' }}
        >
          <path d="M9.86 18a1 1 0 0 1-.73-.32l-4.86-5.17a1 1 0 1 1 1.46-1.37l4.12 4.39 8.41-9.2a1 1 0 1 1 1.48 1.34l-9.14 10a1 1 0 0 1-.73.33z" />
        </svg>
      )}
      {msg && <p>{msg}</p>}
    </div>
  );
}

export default Toast;
